import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import EditStatusOrderDrawer from '@/pages/statusAdmin/EditStatusOrderDrawer.component'

export const Route = createFileRoute('/_auth/status-editor/sort-order')({
  component: () => <EditStatusOrderDrawer />,
})
